// ApplicationDetails.jsx
import React from 'react';
import Step6Upd from '../../../../cabinet/wizplain/components/Step6Upd'; 

const ApplicationDetails = ({ applicationData, mode }) => {
  // Преобразуем данные заявки в формат для Step6Upd
  const formData = {
    child: {
      lastName: applicationData.childLastName,
      firstName: applicationData.childFirstName,
      middleName: applicationData.childMiddleName,
      birthDate: applicationData.birthDate,
      gender: applicationData.gender,
      birthCertificate: {
        seriesNumber: applicationData.birthCertificate,
        issueDate: applicationData.certificateIssueDate,
        country: applicationData.certificateCountry
      },
      addressYur: applicationData.registeredAddress, // Внимание: в Step6 используется addressYur
      addressFact: applicationData.actualAddress,
      sameFactAddress: applicationData.sameAddress ? "yes" : "no"
    },
    applicant: {
      lastName: applicationData.applicantLastName,
      firstName: applicationData.applicantFirstName,
      middleName: applicationData.applicantMiddleName,
      citizenship: applicationData.citizenship,
      hasRnokpp: applicationData.hasRnokpp ? "yes" : "no",
      rnokpp: applicationData.rnokpp,
      documentType: applicationData.documentType,
      documentDetails: applicationData.documentDetails,
      phone: applicationData.phone,
      email: applicationData.email,
      address: applicationData.applicantAddress
    },
    preferences: {
      desiredDate: applicationData.desiredDate,
      ageMenu: applicationData.ageMenu,
      languageTraining: applicationData.languageTraining,
      inclusiveGroup: applicationData.inclusiveGroup,
      diseaseType: applicationData.diseaseType,
      diseaseDocument: applicationData.diseaseDocument,
      withoutBed: applicationData.withoutBed, 
      notWithoutBed: applicationData.notWithoutBed,
      notWithoutFullDay: applicationData.notWithoutFullDay
    },
    benefits: mapBenefitsForDisplay(applicationData.benefits), // Используем функцию маппинга
    selectedSchools: applicationData.selectedSchools || [],
    dictionary: {
      addresses: applicationData.addresses || {}
    },
    agreePersonalData: applicationData.agreePersonalData ? "yes" : "no",
    isDifferentPerson: applicationData.isDifferentPerson,
    invite: applicationData.invite,
    currentStatus: {name: applicationData.currentStatus}
    
  };


  return (
    <div className="application-details">
      <Step6Upd 
        formData={formData}
        errors={{}}
        onChange={() => {}} // Пустая функция, так как режим просмотра
        isPreview={true}
      />
    </div>
  );
};

// Функция для преобразования льгот из массива в формат Step6Upd
const mapBenefitsForDisplay = (benefitsArray) => {
  // Если нет льгот или пустой массив
  if (!benefitsArray || benefitsArray.length === 0) {
    return {}; // Step6 ожидает пустой объект, если нет льгот
  }

  // Step6Upd отображает только первую/текущую льготу
  // (судя по коду, он не поддерживает множественные льготы)
  const primaryBenefit = benefitsArray[0];

  const mappedBenefit = {
    type: primaryBenefit.benefitId, // ID льготы из справочника
  };

  // Добавляем данные в зависимости от типа льготы


  
  // Если есть документы (стандартная льгота)
  if (primaryBenefit.documentType) {
    mappedBenefit.documentType = primaryBenefit.documentType;
    mappedBenefit.documentNumber = primaryBenefit.documentNumber;
    mappedBenefit.issuedTo = primaryBenefit.documentTo;
    mappedBenefit.issueDate = primaryBenefit.documentIssueDate;
    mappedBenefit.docScan = primaryBenefit.documents?.length || 0;
  }

  // Если есть адрес (льгота по месту жительства/работы)
  if (primaryBenefit.address) {
    mappedBenefit.address = primaryBenefit.address;
  }

  // Если это льгота "братья/сестры в одном ЗДО"
  if (primaryBenefit.brothers && primaryBenefit.brothers.length > 0) {
    const sibling = primaryBenefit.brothers[0];
    mappedBenefit.kindergarten = sibling.kindergartenId;
    mappedBenefit.siblingBirthCertificate = sibling.birthCertificate;
    mappedBenefit.siblingName = `${sibling.lastName} ${sibling.firstName}`;
    mappedBenefit.siblingBirthDate = sibling.birthDate;
  }

  // Если это льгота "дети работников"
  if (primaryBenefit.personal) {
    mappedBenefit.employeeName = primaryBenefit.personal.name;
    mappedBenefit.employeeRnokpp = primaryBenefit.personal.rnokpp;
    mappedBenefit.kindergarten = primaryBenefit.kindergartenId;
  }

  return mappedBenefit;
};

export default ApplicationDetails;